import * as React from 'react';
import { connect } from 'react-redux';
import { LottieActions } from './slice';

export interface ILottieAnimationProps {
  name: string;
  autoplay?: boolean;
  loop?: boolean;
  dontKeep?: boolean;
  id?: string;
  stopOn?: number;
  className?: string;
}

export interface IProps extends ILottieAnimationProps {
  onLoad: typeof LottieActions.lottieLoad;
  onUnload: typeof LottieActions.lottieDestroy;
}

export function LottieAnimationContainer({
  name,
  autoplay = false,
  loop = false,
  dontKeep = false,
  id = name,
  stopOn,
  className,
  onLoad,
  onUnload,
}: Readonly<IProps>) {
  React.useEffect(() => {
    onLoad(name, autoplay, loop, dontKeep, id, stopOn);
  }, [onLoad, name, autoplay, loop, dontKeep, id, stopOn]);
  // destroy the animation on unmount and when the id changes, otherwise lottie-web keeps
  // the animation item and its detached container alive for the lifetime of the page
  React.useEffect(
    () => () => {
      onUnload(id);
    },
    [onUnload, id]
  );
  const customClass = className ? ` ${className}` : '';
  const containerClass = `lottie-container${customClass}`;
  return <div id={id} className={containerClass} />;
}

export const mapDispatchToProps = {
  onLoad: LottieActions.lottieLoad,
  onUnload: LottieActions.lottieDestroy,
};

export const LottieAnimation = connect(null, mapDispatchToProps)(LottieAnimationContainer);
export default LottieAnimation;
